import type { GetFeatureFlagsQueryParams } from './getFeatureFlagsOverrides';
import {
  apiVersion as publicApiVersion,
  querySerializer as publicQuerySerializer,
  serializeFlagListFilterParam as publicSerializeFlagListFilterParam,
} from './getFeatureFlagsOverrides';

export type { GetFeatureFlagsQueryParams as GetFeatureFlags1QueryParams };

export function querySerializer(params: GetFeatureFlagsQueryParams) {
  return publicQuerySerializer(params);
}

export function serializeFlagListFilterParam(value: GetFeatureFlagsQueryParams['filter'] = {}) {
  return publicSerializeFlagListFilterParam(value);
}

export const apiVersion = publicApiVersion;
